import { z } from 'zod';
import { REGISTRATION_CHANGE_REASONS } from '../types/vehicleRegistration.types';

export const VRM_MAX_LENGTH = 10;
export const VRM_MIN_LENGTH = 2;

/** 1:1 with StoreRegistrationChangeRequest. The transform runs before the checks so the
 *  plate the user confirmed is the canonical plate that is sent, and so length and
 *  charset measure the stored form. */
export const registrationChangeSchema = z.object({
    newVrm: z
        .string()
        .transform((value) => value.replace(/\s+/g, '').toUpperCase())
        .pipe(
            z
                .string()
                .min(VRM_MIN_LENGTH, 'Enter the new registration')
                .max(VRM_MAX_LENGTH, `A registration cannot exceed ${VRM_MAX_LENGTH} characters`)
                .regex(/^[A-Z0-9]+$/, 'A registration may contain only letters and numbers'),
        ),
    reason: z.enum(REGISTRATION_CHANGE_REASONS, { message: 'Choose why the registration is changing' }),
    // literal(true), not boolean: an unchecked box is a field error rather than a 422.
    sameVehicleConfirmed: z.literal(true, {
        message: 'Confirm this is the same vehicle before changing its registration',
    }),
});

export type RegistrationChangeFormInput = z.input<typeof registrationChangeSchema>;
export type RegistrationChangeFormValues = z.output<typeof registrationChangeSchema>;
